import {
   US_AREA_CODES,
} from '@forwardflow/constants/onboarding.constants'
import { isOperatorEmail } from '@forwardflow/utils/app.utils'
import {
   ArrowLeftMdIcon,
   ChevronRightIcon,
   PhoneIcon,
   SearchMagnifyingGlassIcon,
} from '@forwardflow/icons'
import {
   Button,
   ContentCard,
   Grid,
   Group,
   MultiSelect,
   Stack,
} from '@forwardflow/ui-v2'
import { useOnboardingStoreV2 } from '@forwardflow/store/onboardingStoreV2'
import { useNavigate } from 'react-router-dom'
import { transforStageMappingData } from '@forwardflow/utils/onboarding.utils'
import { useMemo } from 'react'

export const PhoneNumberConfiguration = () => {
   const navigate = useNavigate()
   const {
      getNextStep,
      getPreviousStep,
      onboardingData,
      setStageMappings,
      setIsOnBoardingCompleted,
      setCampaignConfiguration,
      setIsCampaignConfigured
   } = useOnboardingStoreV2()

   const onCompleteOnboarding = () => {
      const updatedTempStageMappings = transforStageMappingData(
         onboardingData?.tempStageGroups
      )
      setStageMappings(updatedTempStageMappings)
      if (isOperatorEmail(onboardingData?.email || '')) {
         navigate('/dashboard')
         return
      }
      setIsOnBoardingCompleted(true)
   }

   const areaCodes = useMemo(() => {
      return onboardingData?.campaignConfiguration?.area_codes || []
   }, [onboardingData?.campaignConfiguration?.area_codes])

   const handleNextStep = () => {
      onCompleteOnboarding()
      setIsCampaignConfigured(true)
      getNextStep()
   }

   return (
      <Stack gap={32}>
         <ContentCard className="space-y-6">
            <p className="text-white font-semibold text-lg ">
               Select Phone Numbers
            </p>
            <Group className="rounded-[16px] border border-[#A684FF]/30 bg-[#A684FF]/5 px-6 py-3">
               <Group
                  justify="center"
                  align="center"
                  className="rounded-[8px] border-[0.667px] border-[#8E51FF]/30 w-10 h-10"
                  style={{
                     background:
                        'var(--fill-icon-linear, linear-gradient(135deg, rgba(79, 57, 246, 0.30) 0%, rgba(127, 34, 254, 0.30) 100%))',
                  }}
               >
                  <PhoneIcon color="#8E51FF" />
               </Group>
               <p className="text-white font-medium">
                  First 3 phone numbers to purchase is on us.
               </p>
            </Group>
            <MultiSelect
               label="Select Area Code to get phone number from"
               leftSection={<SearchMagnifyingGlassIcon width={16} />}
               data={US_AREA_CODES}
               value={areaCodes}
               searchable
               max={3}
               onChange={(value: Array<string>) => {
                  if (value.length <= 3)
                     setCampaignConfiguration({ area_codes: value })
               }}
               placeholder="Search for area code or locality to purchase phone number from.."
            />
         </ContentCard>
         <Grid>
            <Grid.Col span={3}>
               <Button
                  variant="secondary"
                  className="w-full"
                  onClick={() => getPreviousStep()}
               >
                  <ArrowLeftMdIcon width={12} /> Back
               </Button>
            </Grid.Col>
            <Grid.Col span={9}>
               <Button className="w-full" onClick={() => handleNextStep()}>
                  Save Campaign <ChevronRightIcon width={18} />
               </Button>
            </Grid.Col>
         </Grid>
      </Stack>
   )
}
